import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import styles from './FormSearch.module.scss.js';
import Icon from '@piconetworks/pkg-icon';
import Boutton from '@piconetworks/pkg-boutton';

var _excluded = ["children", "className", "isDirty", "isSearching", "onClear"];
var FormSearch = function FormSearch(_ref) {
  var _cx;
  var children = _ref.children,
    className = _ref.className,
    _ref$isDirty = _ref.isDirty,
    isDirty = _ref$isDirty === void 0 ? false : _ref$isDirty,
    _ref$isSearching = _ref.isSearching,
    isSearching = _ref$isSearching === void 0 ? false : _ref$isSearching,
    onClear = _ref.onClear,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var classes = cx(styles.container, (_cx = {}, _cx[styles.searching] = isSearching, _cx[styles.isDirty] = isDirty, _cx), className);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: classes
  }, props), /*#__PURE__*/React.cloneElement(children, {
    isInlineLeft: true,
    isInlineRight: true
  }), isDirty && !isSearching && /*#__PURE__*/React.createElement(Boutton, {
    className: styles.pseudoInline,
    onClick: onClear,
    size: "sm",
    icon: /*#__PURE__*/React.createElement(Icon.Default.Clear, {
      width: 15,
      height: 15
    }),
    variant: "secondary"
  }, "Clear search"));
};
FormSearch.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  children: PropTypes.element,
  isDirty: PropTypes.bool,
  isSearching: PropTypes.bool,
  onClear: PropTypes.func
};

export { FormSearch as default };
//# sourceMappingURL=index.js.map
